import { Domain } from './domain';

export type IImageRoot = () => string;

/**
 * The root URL where images are stored
 */
export const ImageRootProvider = {
  provide: 'imageRoot',
  deps: ['domain'],
  useFactory: (domain: Domain) => {
    return () => domain.createSibling('cdn', true);
  },
};
